import { FuelSource } from "@labs/shared/types/FuelSource.ts";

export const scope1Fuels = [
  FuelSource.FuelOil,
  FuelSource.NaturalGas,
  FuelSource.Diesel,
  FuelSource.Propane,
  FuelSource.Gasoline,
  FuelSource.Refrigerants,
  FuelSource.Carbon,
];
export const scope2Fuels = [FuelSource.Electricity];
